import { CompanyType } from 'src/utils/data/types';

export const getFactoryContacts = (companies, companyTypes) => {
  const factoryTypeId = companyTypes.find(type => type.currentVersion.name === CompanyType.Factory)?.id;
  const factories = companies.filter(company => company.companyTypeId === factoryTypeId);
  const contacts = [];

  factories.forEach(factory => {
    const contactsWithVersion = factory.company.currentVersion.companyContacts;

    contactsWithVersion.forEach(contact => contacts.push(contact.currentVersion));
  });

  return contacts;
};
